export default __webpack_public_path__ + "static/media/dashboard-waiting.27f73f9a.png";